var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{style:(_vm.buttonStyle),attrs:{"to":{ name: 'enterprise-live-map' }}},[_c('to-live-map-button',{staticClass:"aisea-text-12-400-pure-white",attrs:{"buttonText":"LiveMapに戻る"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }